import styled from "styled-components";
import { SPACING } from "../../constants/design/spacing";
import { FONT_CSS } from "../../constants/design/fontSize";
import { TEXT_COLORS } from "../../constants/design/colors";

export const TermsContainer = styled.div`
  display: flex;
  grid-gap: ${SPACING.two}px;
  margin: 0 ${SPACING.two}px;
  position: relative;
  height: 100%;
  > * {
    height: inherit;
  }

  overflow: hidden;
`;

export const PolicyTitle = styled.div`
  ${FONT_CSS.header.five}
`;

export const SectionTitle = styled.div`
  ${FONT_CSS.body.one}
  text-transform: uppercase;
  margin-top: 48px;
  margin-bottom: 24px;
`;

export const SectionQuestion = styled.span`
  ${FONT_CSS.body.two}
  color: ${TEXT_COLORS.one};
  margin-bottom: 16px;
`;

export const SectionAnswer = styled.div`
  ${FONT_CSS.body.two}
  color: ${TEXT_COLORS.two};
  margin-bottom: 24px;
`;
